const HEAD_BYTES = 2 * 1024 * 1024;
const TAIL_BYTES = 2 * 1024 * 1024;

async function rangeFetch(url, from, to, signal) {
  try {
    const res = await fetch(url, { headers: { Range: `bytes=${from}-${to}` }, signal });
    // Body must be drained for bytes to enter the HTTP cache.
    if (res.body) await res.arrayBuffer();
  } catch {
    // partial failures are fine — visible player will fetch what it needs
  }
}

export async function prefetch(url, { sizeBytes, faststart }, signal) {
  const tasks = [rangeFetch(url, 0, HEAD_BYTES - 1, signal)];
  if (faststart === false && sizeBytes && sizeBytes > HEAD_BYTES + TAIL_BYTES) {
    // Non-faststart MP4 stores moov at the end — warm the tail too so the
    // visible <video> doesn't pay an extra round-trip on first seek.
    tasks.push(rangeFetch(url, sizeBytes - TAIL_BYTES, sizeBytes - 1, signal));
  }
  await Promise.allSettled(tasks);
}
